import { styled } from '@mui/material';

export const Paragraph = styled('p')({
  fontSize: 16,
  marginTop: 14,
  marginLeft: 34,
});

export const MessagesContainer = styled('ul')({
  marginTop: 14,
  marginLeft: 60,
});

export const Message = styled('li')({
  fontSize: 16,
});